import type { MockDatabase } from "@/types/domain";
import type { MockRequest, MockResponse } from "@/mocks/router";
import { store } from "@/mocks/store";
import { err, matchPath, nowStamp, ok, paginate } from "./_utils";

export function handleContent(req: MockRequest): MockResponse | null {
  const method = req.method.toUpperCase();
  const path = req.path.replace(/\/+$/, "") || "/";
  const { query, body } = req;

  if (method === "GET" && path === "/api/temples") return ok(paginate(store.TEMPLATES, query));
  if (method === "POST" && path === "/api/temples") {
    const payload = body as Partial<MockDatabase["TEMPLATES"][number]>;
    const temple = {
      id: payload.id || `tpl_${Date.now().toString(36)}`,
      temple_id: payload.temple_id || `temple_${Date.now().toString(36)}`,
      name: payload.name || "新模版",
      category: payload.category || "基础",
      icon: payload.icon || "⬜",
      color: payload.color || "from-white to-slate-100",
      desc: payload.desc || "",
      channels: payload.channels || 0,
      languages: payload.languages || 1,
      used_count: 0,
      is_official: !!payload.is_official,
      is_default: !!payload.is_default,
      updated: nowStamp().slice(0, 10),
      sample_title: payload.sample_title || "",
      layout: payload.layout,
    };
    store.TEMPLATES.push(temple);
    return ok({ data: temple }, 201);
  }
  {
    const m = matchPath("/api/temples/:id", path);
    if (m && method === "GET") {
      const item = store.TEMPLATES.find((x) => x.id === m.id || x.temple_id === m.id);
      if (!item) return err(404, "NOT_FOUND", "模版不存在");
      return ok({ data: item });
    }
    if (m && method === "PATCH") {
      const idx = store.TEMPLATES.findIndex((x) => x.id === m.id || x.temple_id === m.id);
      if (idx < 0) return err(404, "NOT_FOUND", "模版不存在");
      store.TEMPLATES[idx] = { ...store.TEMPLATES[idx], ...(body as object), updated: nowStamp().slice(0, 10) };
      return ok({ data: store.TEMPLATES[idx] });
    }
  }

  if (method === "GET" && path === "/api/landing-pages") return ok(paginate(store.LANDING_PAGES, query));
  if (method === "POST" && path === "/api/landing-pages") {
    const payload = body as Partial<MockDatabase["LANDING_PAGES"][number]>;
    const lp = {
      id: payload.id || `lp_${Date.now().toString(36)}`,
      temple_id: payload.temple_id ?? null,
      source_type: payload.source_type || "temple",
      content_type: payload.content_type || "share_content",
      name: payload.name || "未命名落地页",
      audience_rule: payload.audience_rule || "",
      owner: payload.owner || store.ROLES[store.SESSION.currentRole]?.user || "unknown",
      created_at: nowStamp(),
      updated_at: nowStamp(),
      status: payload.status || "draft",
      title: payload.title || "",
      url: payload.url,
      scenario_ids: payload.scenario_ids,
    };
    store.LANDING_PAGES.push(lp);
    return ok({ data: lp }, 201);
  }
  {
    const m = matchPath("/api/landing-pages/:id/publish", path);
    if (m && method === "POST") {
      const idx = store.LANDING_PAGES.findIndex((x) => x.id === m.id);
      if (idx < 0) return err(404, "NOT_FOUND", "落地页不存在");
      store.LANDING_PAGES[idx].status = "released";
      store.LANDING_PAGES[idx].updated_at = nowStamp();
      return ok({ data: store.LANDING_PAGES[idx] });
    }
  }
  {
    const m = matchPath("/api/landing-pages/:id", path);
    if (m && method === "GET") {
      const item = store.LANDING_PAGES.find((x) => x.id === m.id);
      if (!item) return err(404, "NOT_FOUND", "落地页不存在");
      return ok({ data: item });
    }
    if (m && method === "PATCH") {
      const idx = store.LANDING_PAGES.findIndex((x) => x.id === m.id);
      if (idx < 0) return err(404, "NOT_FOUND", "落地页不存在");
      store.LANDING_PAGES[idx] = { ...store.LANDING_PAGES[idx], ...(body as object), updated_at: nowStamp() };
      return ok({ data: store.LANDING_PAGES[idx] });
    }
  }

  return null;
}
